import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/halloween/items/three-pirates.png")